import API, { APIResponse } from '../../../lib/commons/api'
import { WbsItemBasic } from '../../../lib/functions/wbsItem'
import { UserBasic } from '../../../domain/value-object/UserBasicVO'

export interface WbsItemCriticalPathResponse {
  uuid: string
  projectUuid: string
  fromWbsItemUuid: string
  fromProjectPlanUuid: string
  fromDate: string // "YYYY-MM-DD"
  toWbsItemUuid: string
  toProjectPlanUuid: string
  toDate: string // "YYYY-MM-DD"
  color: string | null
  description: string | null
  lockVersion: number
  fromWbsItem: WbsItemBasic
  toWbsItem: WbsItemBasic
  createdAt: number
  createdBy: UserBasic
  updatedAt: number
  updatedBy: UserBasic
}

interface CriticalPathDeltaRequest {
  added: {
    uuid: string
    fromWbsItemUuid: string
    fromDate: string
    toWbsItemUuid: string
    toDate: string
    color?: string
    description?: string
  }[]
  edited: {
    uuid: string
    fromDate: string
    toDate: string
    color?: string
    description?: string
  }[]
  deleted: { uuid: string }[]
}

export const getWbsItemCriticalPaths = (): Promise<APIResponse> =>
  API.functional.request(
    'GET',
    '/api/v1/projects/wbs_item_critical_paths',
    undefined
  )

export const saveWbsItemCriticalPaths = (
  request: CriticalPathDeltaRequest
): Promise<APIResponse> =>
  API.functional.request(
    'POST',
    '/api/v1/projects/wbs_item_critical_paths/delta/batch',
    request
  )
